import { action, makeObservable, observable } from 'mobx';

import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { OptionEntity } from '@/types/OptionEntity';

export type TabsStoreOptions<I extends OptionEntity<string, string> = OptionEntity<string, string>> = {
  items: I[];
  defaultActiveKey?: I['key'];
};

export class TabsStore<I extends OptionEntity<string, string> = OptionEntity<string, string>> implements ILocalStore {
  items: I[];
  activeKey: I['key'];

  constructor({ items, defaultActiveKey }: TabsStoreOptions<I>) {
    this.items = items;

    this.activeKey = defaultActiveKey ?? items[0].key;

    makeObservable(this, {
      items: observable.ref,
      activeKey: observable,
      setActiveKey: action.bound,
    });
  }

  setActiveKey(key: I['key']): void {
    this.activeKey = key;
  }

  destroy() {
    // no to do
  }
}
